// Fallback de CAPACIDADE (não marca) pro tracked-query do TanStack Query v5 no
// PISO do produto (Chromium 38 = webOS 3.5/2017), que NÃO tem `Proxy`.
//
// CLASSE do bug (P0 capturado no motor real Chr38, rev 290036): o TanStack v5
// implementa o "tracked query" (rastrear quais campos do result o componente lê
// pra re-renderizar só quando ELES mudam) com `new Proxy(result, ...)` no
// `QueryObserver.trackResult`. O `useBaseQuery` chama isso SEM guarda:
//
//     return !defaultedOptions.notifyOnChangeProps
//       ? observer.trackResult(result)   // <- new Proxy(...)  ← ES2015, Chr49+
//       : result
//
// `Proxy` é ES2015 e só existe do Chromium 49 pra cima. No piso Chr38 a
// referência `Proxy` é indefinida, então TODO `useQuery` lança
// `ReferenceError: Proxy is not defined` DURANTE O RENDER — antes de qualquer
// efeito ou `<video>` — e a RecoveryBoundary cai no "Algo deu errado". Ou seja:
// numa instalação de loja em TV webOS 3.5, o app inteiro morre no 1º `useQuery`
// (home, catálogo, ficha, player — qualquer tela).
//
// FIX da classe (por capability, nunca por marca): quando `Proxy` não existe,
// setamos `notifyOnChangeProps: 'all'` no default do QueryClient. Aí o
// `useBaseQuery` devolve o `result` CRU (o ramo `: result` acima) e nunca toca
// em `Proxy`. Custo: sem o tracking, o componente re-renderiza a cada mudança de
// QUALQUER campo do result (não só os lidos) — aceitável e correto (nunca stale)
// no punhado de TVs sem Proxy. Nos engines COM Proxy (webOS 4+, Tizen novo, web)
// devolvemos `{}` e o tracked-query default segue intacto: ZERO regressão de perf
// onde importa.
//
// Pura + parametrizada (recebe `hasProxy`, não lê o global) pra o teste-controle
// provar os dois ramos sem mexer no `globalThis`.

/**
 * @param hasProxy `typeof Proxy !== 'undefined'` no engine corrente.
 * @returns patch pra espalhar em `defaultOptions.queries`: `{}` quando há Proxy
 *   (mantém tracked-query), `{ notifyOnChangeProps: 'all' }` quando não há.
 */
export function proxyTrackingFallback(hasProxy: boolean): { notifyOnChangeProps?: 'all' } {
  return hasProxy ? {} : { notifyOnChangeProps: 'all' }
}

/** Detecta a capacidade no engine corrente (isolado pra facilitar o stub em teste). */
export function engineHasProxy(): boolean {
  return typeof Proxy !== 'undefined'
}
